import { Component, OnInit, ViewChild, ElementRef, OnDestroy } from '@angular/core';

import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';

import { config, time, messages } from 'app/constants';
import { datetimeFormat } from 'app/constants/date-time-format';
import { templateTypes } from 'app/constants/templates/template-type';
import { MktEmailTemplate } from 'app/modules/app-components/mkt-email-template-dialog/mkt-email-template-dialog.component';
import { DataService, HTTPService, HelperService, DateService } from 'app/services';

import { UpdateRecipientDialogComponent } from '../update-recipient-dialog/update-recipient-dialog.component';
import { MktSMSTemplate } from '../mkt-sms-template-dialog/mkt-sms-template-dialog.component';

import { Subscription } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { getLanguagePreferences, setLanguagePreferences } from 'app/constants/language-translate';

@Component({
  selector: 'ngx-send-inspection',
  templateUrl: './send-inspection.component.html',
  styleUrls: ['./send-inspection.component.scss'],
  providers: [DialogService],
})
export class SendInspectionComponent implements OnInit, OnDestroy {
  @ViewChild('sendDialog', { static: true }) sendDialog: ElementRef;

  card: any = {
    messages: {
      heading: 'Display Messages',
      content: 'Allow customers to view messages on estimates and invoices.',
      switch: false,
    },
    feed: {
      heading: 'Display Activity Feed',
      content: 'Allow customers to view messages on estimates and invoices.',
      switch: false,
    },
    reminders: {
      heading: 'Reminder',
      content: 'Send the customer reminder on',
      switch: true,
    },
  };
  defaultReminder: any = [
    {
      primary: true,
      message: '',
      label: 'tomorrow',
      day: 1,
      time: this.getCurrentSelectedTime().value,
    },
    {
      primary: true,
      message: '',
      label: ': 2 days from now',
      day: 2,
      time: this.getCurrentSelectedTime().value,
    },
  ];
  recipients = {
    emails: [],
    phones: [],
  };
  reminderRecipients = {
    emails: [],
    phones: [],
  };
  reminderRecipientTooltip: string = '';
  notificationRecipientTooltip: string = '';
  useConfirmationRecipient: boolean = false;
  isProcessing: boolean = false;
  sendButtonTitle = 'Send';

  reminders: any[] = [...this.defaultReminder];
  customer: any = {};
  vehicle: any = {};
  title: string = '';
  data: any = {};
  order: any = {};
  company: any = {};
  shopLocation: any = {};
  templateType: string = '';
  inspectionId: string = '';
  subject: string = '';
  content: string = '';
  defaultContent: string = '';
  inspectionTitle: string = '';
  isEmailSelected: boolean = false;
  isSMSSelected: boolean = false;
  isReminderEnabled: boolean = false;
  isDisplayMessage: boolean = false;
  isDisplayFeed: boolean = false;
  isSchedulePickUp: boolean = true;
  pickUpDateTime: any;
  logActivity: any;
  inspectionTime: any;
  selectedTime: any = {};
  timezones: any = {};
  pickUpDate: any = '';
  times = [];
  reminderTemplate: any = {};
  currentTime: any;
  payment = {
    cash: 0,
    cheque: 0,
    card: 0,
    creditPayment: 0,
    thirdParty: 0,
  };
  estimateTemplate: any = {};
  invoiceTemplate: any = {};
  inspectionTemplate: any = {};
  vehiclePickupTemplate: any = {};
  approvalReminderTemplate: any = {};
  templateKeys = {
    ESTIMATE: 'estimateTemplate',
    INVOICE: 'invoiceTemplate',
    INSPECTION: 'inspectionTemplate',
    INVOICE_VEHICLE_PICKUP: 'vehiclePickupTemplate',
    ESTIMATE_APPROVAL_REMINDER: 'approvalReminderTemplate',
  };
  serverTime: any = 0;
  isInspectionsVisible: boolean = true;
  inspectionsStatus: any = {};
  contacts: any[] = [];
  dataServiceSubscription: Subscription;
  shop: any = {
    shopName: '',
    shopContact: '',
  };
  hasFollowUps: boolean = false;
  estimationData: any = {};
  isSent: boolean = false;
  isMultiLocationEnabled: boolean = false;
  currentLang: string = 'en';
  companyLocalization: boolean = false;
  customerId: string;

  constructor(
    public ref: DynamicDialogRef,
    public dConfig: DynamicDialogConfig,
    public dialogService: DialogService,
    private httpService: HTTPService,
    private helperService: HelperService,
    public dataService: DataService,
    public dateService: DateService,
    private translate: TranslateService,
  ) { }

  async ngOnInit() {
    const { companyName, companyPhone, isMultiLocationEnabled } = this.helperService.getCompany();
    this.shop = {
      shopName: companyName,
      shopContact: this.helperService.formatPhoneNumber(companyPhone),
    };
    this.times = time;
    this.isMultiLocationEnabled = isMultiLocationEnabled;
    this.getTemplates();
    this.setDataListener();
    this.customerId = this.helperService.deepCopy(this.dConfig.data.data.customer.customerId);

    this.httpService.getCustomerPreferredLanguage(this.customerId).then((res) => {
      this.companyLocalization = this.dataService.companyLocalization;
      if (this.companyLocalization) {
        this.currentLang = res.preferredLanguage.toLowerCase();
        this.getTemplates();
      } else {
        this.currentLang = 'en';
      }
    });
  }

  switchLanguage() {
    if (this.currentLang === 'en') {
      this.translate.use('fr');
      this.getTemplates('fr');
      this.currentLang = 'fr';
      this.httpService.updateCustomer({ _id: this.order.customer.customerId, preferredLanguage: 'fr'.toUpperCase() }).then((res) => {
        this.helperService.showToaster('success', 'Language updated successfully');
      });
      // setLanguagePreferences('fr', this.companyLocalization);
    } else {
      this.translate.use('en');
      this.getTemplates('en');
      this.currentLang = 'en';
      this.httpService.updateCustomer({ _id: this.order.customer.customerId, preferredLanguage: 'en'.toUpperCase() }).then((res) => {
        this.helperService.showToaster('success', 'Language updated successfully');
      });
      // setLanguagePreferences('en', this.companyLocalization);
    }
  }

  ngOnDestroy() {
    if (this.dataServiceSubscription) {
      this.dataServiceSubscription.unsubscribe();
    }
  }

  setDataListener() {
    this.dataServiceSubscription = this.dataService.getData().subscribe(({ data }) => {
      if (data) {
        if (data.key === 'company-appdata-updated') {
          this.dataServiceSubscription.unsubscribe();
        }
      }
    });
  }

  handleOpenTemplate(marketingTemplate: any) {
    const component = marketingTemplate && marketingTemplate.templateType === 'SMS' ? MktSMSTemplate : MktEmailTemplate;

    this.dialogService.open(component, {
      styleClass: 'add-dialog mkt-email-template-dialog-dialog',
      showHeader: false,
      data: { isOpenedFromCampaign: true, campaignTemplateId: marketingTemplate && marketingTemplate.marketingTemplateId, campaignTemplateText: marketingTemplate.text, isReadOnly: true },
    });
  }

  async getCustomerContacts() {
    if (!this.order.customer) return;

    try {
      const { contactInfo, contactEntityId } = await this.httpService.getContactInfo(this.order.customer.customerId, true, {
        contactEntityType: 'customer',
      });

      if (contactInfo && contactInfo.length) {
        this.setRecipient(contactInfo);
      }

      if (contactEntityId && contactEntityId._id) {
        this.customer.firstName = contactEntityId.firstName;
        this.customer.lastName = contactEntityId.lastName;
      }
    } catch (err) { }
  }

  /** Getting all templates */
  getTemplates(lang?: string) {
    const { estimate, inspection, invoice, invoice_vehicle_pickup, estimate_approval_reminder } = templateTypes;

    this.httpService
      .getMultipleTemplates(
        {
          type: [estimate, inspection, invoice, invoice_vehicle_pickup, estimate_approval_reminder],
          language: lang ? lang.toUpperCase() : this.currentLang.toUpperCase(),
        },
        true,
        { fetchTimezones: true },
      )
      .then(
        ({ templates, company, shop, timezones, serverTime }) => {
          this.company = company;
          this.shopLocation = shop;
          this.timezones = timezones;
          this.serverTime = new Date(serverTime);
          this.populateTemplates(templates);
          this.populateData();
          this.updateInspectionInEmail();
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      );
  }

  /** Populating all templates */
  populateTemplates(templates: any[]) {
    templates.forEach((template) => {
      const templateKey = this.templateKeys[template.type];
      this[templateKey] = template;
    });
  }

  /** Populating the date */
  async populateData() {
    const data = this.helperService.deepCopy(this.dConfig.data);
    this.title = data.title;
    this.data = data.data;
    this.order = data.data;

    if (data.fetchNew) {
      const order: any = await this.httpService.getEstimateById(this.order._id, false);
      if (order.customer && order.customer.customerId) {
        order.customer = {
          ...order.customer,
          ...order.customer.customerId,
          customerId: order.customer.customerId._id,
        };
      }

      if (order.vehicle && order.vehicle.vehicleId) {
        order.vehicle = {
          ...order.vehicle.vehicleId,
          vehicleId: order.vehicle.vehicleId._id,
        };
      }
      this.data = order;
      this.order = order;
    }

    this.customer = data.customer;
    this.vehicle = data.vehicle;
    this.templateType = data.templateType;
    this.inspectionId = data.inspectionId;
    this.inspectionTitle = data.inspectionTitle;
    this.logActivity = data.logActivity;
    this.inspectionTime = data.inspectionTime;
    this.customer = { ...(this.order.customer || {}) };
    this.vehicle = { ...(this.order.vehicle || {}) };
    this.isEmailSelected = this.order.customer.isEmail;
    this.isSMSSelected = this.order.customer.isSMS;

    this.order.services.forEach(({ _id, includeInInvoice, inspection }) => {
      if (inspection && inspection.inspectionId && includeInInvoice) {
        this.inspectionsStatus[_id] = true;
      }
    });

    await this.getCustomerContacts();
    const templateKey = this.templateKeys[this.templateType];
    const template = this[templateKey];
    if (template) {
      this.subject = this.parseTemplate(template.subject);
      this.content = this.parseTemplate(template.contents);
    }
  }

  /** handle toggling statuses  */
  toggleActiveState(type: string, active: boolean) {
    this[type] = active;

    if (['isEmailSelected', 'isSMSSelected'].includes(type)) {
      this.setRecipient(this.contacts, type);
      return;
    }
  }

  toggleInspectionVisibilty() {
    this.isInspectionsVisible = !this.isInspectionsVisible;
  }

  parseTemplate(content: string) {
    const parseData = {
      pickUpDateTime: this.pickUpDateTime,
      company: this.isMultiLocationEnabled ? this.shopLocation : this.company,
      customer: this.customer,
      vehicle: this.vehicle,
      order: {
        title: this.order.title,
        code: this.order.code,
        invCode: this.order.invCode,
        paid: this.payment.card + this.payment.cheque + this.payment.cash + this.payment.creditPayment + this.payment.thirdParty,
        authStatus: this.order.authorized ? 'approved' : 'not approved',
        orderStatus: this.order.orderStatus,
        total: this.order.total && this.order.total.grand,
      },
    };

    return this.helperService.templateParser(content, parseData, false, this.timezones);
  }

  revertParse(content: string) {
    const parseData = {
      pickUpDateTime: this.pickUpDateTime,
      company: this.company,
      customer: this.customer,
      vehicle: this.vehicle,
      order: {
        title: this.order.title,
        code: this.order.code,
        invCode: this.order.invCode,
        paid: this.payment.card + this.payment.cheque + this.payment.cash + this.payment.creditPayment + this.payment.thirdParty,
        authStatus: this.order.authorized ? 'approved' : 'not approved',
        orderStatus: this.order.orderStatus,
        total: this.order.total && this.order.total.grand,
      },
    };

    return this.helperService.revertTemplateParsing(content, parseData);
  }

  preview() {
    if (!Object.values(this.inspectionsStatus).includes(true)) {
      this.helperService.showToaster('error', 'Kindly select inspection');
      return;
    }
    let url = `${config.redirectUrl.inspectionPreview}`;

    if (this.data._id) {
      url += this.data._id;
    }

    if (this.inspectionId) {
      url += `/${this.inspectionId}`;
    }
    this.helperService.openPageInNewTab(
      this.helperService.constructQueryParams(url, {
        isPreview: true,
        lang: this.currentLang,
        localization: this.companyLocalization,
        inspections: Object.keys(this.inspectionsStatus)
          .map((id) => id)
          .filter((id) => this.inspectionsStatus[id]),
      }),
    );
  }

  subjectChange(value: string = '') {
    this.subject = value;
  }

  onSubmit() {
    let contacts = [];
    if (!this.isEmailSelected && !this.isSMSSelected) {
      this.helperService.showToaster('error', messages.communicationPreference);
      return;
    }

    if (this.order.orderStatus === 'estimate') {
      contacts = [...this.recipients.emails, ...this.recipients.phones, ...this.reminderRecipients.emails, ...this.reminderRecipients.phones];

      if (!contacts.length) {
        this.helperService.showToaster('error', 'No contact selected');
        return;
      }
    } else {
      contacts = [...this.recipients.emails, ...this.recipients.phones];

      if (!contacts.length) {
        this.helperService.showToaster('error', 'No contact selected');
        return;
      }
    }

    const data = this.data;
    if (this.templateType !== 'estimate') {
      data.inspectionTime = this.inspectionTime;
      data.inspectionId = this.inspectionId;
      data.inspectionTitle = this.inspectionTitle;
    }

    const communicationType = 'inspection';
    data.customer = this.customer;
    data.vehicle = this.vehicle;
    data.reminders = this.isReminderEnabled ? this.reminders : [];
    data.recipients = [...this.recipients.emails, ...this.recipients.phones];
    data.reminderRecipients = [...this.reminderRecipients.emails, ...this.reminderRecipients.phones];
    data.communication = {
      type: communicationType,
      isSMS: this.isSMSSelected,
      isEmail: this.isEmailSelected,
      isMessage: this.isDisplayMessage,
      isActivity: this.isDisplayFeed,
      phone: this.customer && this.customer.phone,
      email: this.customer && this.customer.email,
      subject: this.subject,
      contents: this.content,
      latest: true,
    };

    data.isPickupScheduled = this.isSchedulePickUp;

    if (this.isSchedulePickUp) {
      data.pickupDate = this.pickUpDateTime;
    }

    data.inspectionsStatus = this.inspectionsStatus;

    this.sendOrderInvoice(data);
  }

  handleReminderEnableChange(isReminderEnabled: boolean) {
    this.isReminderEnabled = isReminderEnabled;
  }

  sendOrderInvoice(data: any) {
    let appointment: any = {};
    const endTime = this.helperService.addDuration(this.pickUpDateTime, 15, 'm');
    if (this.templateType === templateTypes.invoice && this.isSchedulePickUp) {
      appointment = {
        customer: this.customer,
        estimate: this.data,
        vehicle: this.vehicle,
        isEmail: this.customer.isEmail,
        isSMS: this.customer.isSMS,
        title: `${(this.vehicle && this.vehicle.name) || 'Untitled'} Pickup`,
        color: '#4E94C8',
        startDateTime: `${this.helperService.parseDateForTimeZone(this.pickUpDateTime)}`,
        endDateTime: `${this.helperService.parseDateForTimeZone(endTime)}`,
      };
    }

    this.isProcessing = true;
    this.httpService
      .sendInspection(data._id, { ...data, appointment })
      .then(
        (estimationData: any) => {
          if (this.templateType === templateTypes.invoice) {
            this.helperService.showToaster('success', messages.invoiceSent);
          } else if (this.templateType === templateTypes.estimate) {
            this.helperService.showToaster('success', messages.estimateSent);
          } else {
            this.helperService.showToaster('success', messages.emailSent);
          }
          this.isSent = true;
          this.sendButtonTitle = 'Sent';
          // if (this.hasFollowUps) {
          this.estimationData = estimationData;
          if (this.dataService.isGainSightPXEnabled && Object.keys(data.inspectionsStatus).length) {
            const estimateSentDvi: any = {
              inspectionsCount: Object.keys(data.inspectionsStatus).length,
              inspectionsName: this.getAttachedInspections(data.services),
              roNumber: data.code,
              customerName: data.customer?.fullName,
              vehicleName: data.vehicle?.name,
            };

            (<any>window).aptrinsic('track', 'DVI Sent to Customer', estimateSentDvi);
          }
          const attributePX = {
            customerName: data.customer?.fullName,
            roNumber: data.code,
            isEmailSelected: this.isEmailSelected,
            isSMSSelected: this.isSMSSelected
          }
          if (this.currentLang.toLowerCase() === 'fr') {
            this.helperService.postGainsightPXEvent('Inspection reports sent in French', attributePX);
          }
          this.close(estimationData);

          if (estimationData.orderStatus === 'estimate' && estimationData.sendEstimate) {
            this.order.sendEstimate = this.dateService.formatDate(this.dateService.getCurrentDateTimeTz(new Date(estimationData.sendEstimate).getTime()), datetimeFormat.mmmdyyhhmmaa);
          }
        },
        (err) => {
          this.helperService.showToaster('error', err);
        },
      )
      .finally(() => {
        this.isProcessing = false;
      });
  }

  /** Scrolling the modal to the bottom */
  scrollToBottom() {
    setTimeout(() => {
      this.sendDialog.nativeElement.scrollTop = this.sendDialog.nativeElement.scrollHeight;
    }, 100);
  }

  getAttachedInspections(services) {
    let inspectionNames = '';
    services.forEach((element) => {
      if (element.inspection && element.inspection.inspectionId) {
        inspectionNames += !inspectionNames ? `${element.inspection.inspectionId.title}` : `, ${element.inspection.inspectionId.title}`;
      }
    });

    return inspectionNames;
  }

  deleteReminder(index: number) {
    if (this.reminders && this.reminders.length) {
      this.reminders.splice(index, 1);
    }
  }

  addReminder() {
    if (this.reminders && this.reminders.length) {
      this.reminders.push(this.defaultReminder);
    }
  }

  getCurrentSelectedTime(): any {
    const nowDate = this.helperService.convertDate(new Date());
    const currentHour = nowDate.format('HH');
    const currentMin = nowDate.format('mm');

    if (time) {
      const startHourSlots = time.filter((t) => t.hour === currentHour);

      if (this.helperService.toNumber(currentMin) >= 45) {
        if (this.times) {
          return this.times.filter((t) => t.i === startHourSlots[3].i + 1)[0];
        } else {
          return {};
        }
      } else if (this.helperService.toNumber(currentMin) >= 30 && this.helperService.toNumber(currentMin) < 45) {
        return startHourSlots[3];
      } else if (this.helperService.toNumber(currentMin) >= 15 && this.helperService.toNumber(currentMin) < 30) {
        return startHourSlots[2];
      } else if (this.helperService.toNumber(currentMin) >= 0 && this.helperService.toNumber(currentMin) < 15) {
        return startHourSlots[1];
      }
    }

    return {};
  }

  handleInspectionChange(serviceId: string, isChecked: boolean) {
    this.inspectionsStatus[serviceId] = isChecked;
    this.updateInspectionInEmail();
    !Object.values(this.inspectionsStatus).includes(true) ? (this.isSent = true) : (this.isSent = false);
  }

  updateInspectionInEmail() {
    const status = [...Array.from(new Set(Object.values(this.inspectionsStatus)))];

    if (!status.length) {
      return;
    }
  }

  /** Closing the send dialog */
  close(data: any) {
    this.ref.close(data);
    this.ref.close(this.estimationData);
  }

  openUpdateRecipientDialog(type: string) {
    if (!this.isSMSSelected && !this.isEmailSelected) return;
    if (this.useConfirmationRecipient && type === 'reminder') return;

    let recipients = [];

    if (type === 'confirmation') {
      recipients = [...this.recipients.emails.map(({ value }) => value), ...this.recipients.phones.map(({ value }) => value)];
    } else {
      recipients = [...this.reminderRecipients.emails.map(({ value }) => value), ...this.reminderRecipients.phones.map(({ value }) => value)];
    }

    const ref = this.dialogService.open(UpdateRecipientDialogComponent, {
      closeOnEscape: false,
      width: '650px',
      styleClass: 'add-dialog add-receipt-modal update-contact-dialog',
      showHeader: false,
      data: {
        customerId: this.order.customer.customerId,
        email: this.order.customer.email,
        phone: this.order.customer.phone,
        recipients: this.helperService.deepCopy(recipients),
        contactOnPhone: this.isSMSSelected,
        contactOnEmail: this.isEmailSelected,
      },
    });

    const onClose = ref.onClose.subscribe(({ isSuccess, data }) => {
      if (isSuccess) {
        const recipients = {
          emails: [],
          phones: [],
        };

        if (data.contacts && data.contacts && data.contacts.length) {
          for (let i = 0; i < data.contacts.length; i++) {
            const { _id, value, contactType, isChecked } = data.contacts[i];
            const contact = {
              value,
              recipientId: _id,
              type: contactType,
            };

            if (isChecked) {
              if (contactType === 'email') {
                recipients.emails.push(contact);
              } else {
                recipients.phones.push(contact);
              }
            }
          }
        }

        if (type === 'confirmation') {
          this.recipients = this.helperService.deepCopy(recipients);

          if (this.useConfirmationRecipient) {
            this.reminderRecipients = this.helperService.deepCopy(this.recipients);
          }
        } else {
          this.reminderRecipients = this.helperService.deepCopy(recipients);
        }

        this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
        this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder');
      }

      onClose.unsubscribe();
    });
  }

  setRecipient(contacts: any[], type: string = '') {
    this.contacts = contacts;

    if (!this.isEmailSelected) {
      this.recipients.emails = [];
      this.reminderRecipients.emails = [];
    }

    if (!this.isSMSSelected) {
      this.recipients.phones = [];
      this.reminderRecipients.phones = [];
    }

    if (contacts && contacts.length) {
      contacts.forEach(({ _id, value, contactType, isPrimary }: any) => {
        if (isPrimary) {
          if (contactType === 'email' && this.isEmailSelected && ['', 'isEmailSelected'].includes(type)) {
            this.recipients.emails = [
              {
                type: 'email',
                value: value,
                recipientId: _id,
              },
            ];
          } else if (contactType === 'mobile' && this.isSMSSelected && ['', 'isSMSSelected'].includes(type)) {
            this.recipients.phones = [
              {
                type: 'mobile',
                value: value,
                recipientId: _id,
              },
            ];
          }
        }
      });
    }

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
    }

    this.notificationRecipientTooltip = this.helperService.createContactTooltip(this.recipients, 'Confirmation');
    this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder');
  }

  handleUseConfirmationRecipientChange(useConfirmationRecipient: boolean) {
    this.useConfirmationRecipient = useConfirmationRecipient;

    if (this.useConfirmationRecipient) {
      this.reminderRecipients = this.helperService.deepCopy(this.recipients);
      this.reminderRecipientTooltip = this.helperService.createContactTooltip(this.reminderRecipients, 'Reminder');
    }
  }
}
